import { actionNames } from "constants/index";
const mapDispatchToProps = (dispatch) => ({
  CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO: (citaEnProceso) =>
    dispatch({
      type: actionNames.CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO,
      state: { citaEnProceso: citaEnProceso },
    }),
  SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO: (
    idSolicitudGeneradoNacional
  ) =>
    dispatch({
      type: actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO,
      state: { idSolicitudGeneradoNacional: idSolicitudGeneradoNacional },
    }),
});
export default mapDispatchToProps;
